$(document).ready(function () {
  // Enable checkboxes after page load
  $("input[type='checkbox']").prop("disabled", false);

  // Scroll to top on page unload
  $(window).on("beforeunload", function () {
    $(window).scrollTop(0);
  });
 
  // Show/Hide header tabs
  $(".tab").click(function () {
    let tabId = $(this).attr("data-id");

    $(".tab-content").removeClass("active-tab-content");
    $(`.tab-content[data-id='${tabId}']`).addClass("active-tab-content");

    $(".tab").removeClass("active-tab");
    $(this).addClass("active-tab");

    $("#searchbar").val("").trigger("keyup");
    $("html, body").animate({ scrollTop: 0 }, 500, "swing");
  });

  // Sticky header on scroll
  $(window).scroll(function () {
    let height = $(window).height();
    let scroll = $(window).scrollTop();
    $(".sticky-header").toggleClass("show", scroll > height);
  });

  // Passing line-items on clicking submit button
  $(".flex_box_submit").click(function () {
    let items = 1;
    let itemCount = 1;
    let totalPrice = 0;
    let props = {
          _bundle_productX: $("input[name='properties[_bundle_productX]']").val() || ""
       };

    $("#flexi-box-form")
      .find(".product-checkbox:checked")
      .each(function () {
        let quantity = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
        let bundleParts = $(this).attr("data-bundle").split("/");
        totalPrice += parseFloat(bundleParts[1]) * quantity;
        props["ITEM"+itemCount] = $(this).val() || "";
        itemCount++;
      });

    $("#flexi-box-form")
      .find(".product-checkbox:checked")
      .each(function () {
        let $checkbox = $(this);
        let productValue = $checkbox.val();
        let productName = $checkbox.attr("name") || "";

        // Skip hidden/invalid items
        if (
          !productValue ||
          productValue.toLowerCase() === "no" ||
          productValue.toLowerCase().includes("hidden") ||
          productName.toLowerCase().includes("hidden")
        ) {
          $checkbox.prop("disabled", true);
          return;
        }

        // Quantity handling
        let bundle = $checkbox.attr("data-bundle");
        let quantity = parseInt($checkbox.closest(".product-info").find(".quantity-input").val()) || 1;

        // Store original value (without qty)
        let originalValue = $checkbox.attr("data-original-value") || productValue.split(" (Qty:")[0];
        $checkbox.attr("data-original-value", originalValue);

        let productProperty = originalValue;
        if (quantity > 1) {
          productProperty += ` (Qty: ${quantity})`;
        }

        $checkbox.attr("name", "properties[ITEM" + items + "]");
        $checkbox.val(productProperty);

        // Update bundle if quantity > 1
        let bundleParts = bundle.split("/");
        if (bundle && quantity > 1) {
          if (bundleParts.length >= bundleQty) {
            let update_price = (parseFloat(bundleParts[1]) * quantity / totalPrice) * bundlePrice;
            bundleParts[1] = Math.round(update_price);
            bundleParts[2] = quantity;
            bundle = bundleParts.join("/");
          }
        } else {
          let update_price = (parseFloat(bundleParts[1]) / totalPrice) * bundlePrice;
          bundleParts[1] = Math.round(update_price);
          bundle = bundleParts.join("/");
        }

        $("<input>")
          .attr("type", "hidden")
          .attr("name", "properties[_bundle_product" + items + "]")
          .val(bundle)
          .appendTo("#flexi-box-form");
        props["_bundle_product" + items] = bundle;
        items++;
      });

    if($(this).attr('id') == 'submit-btn') {
        $(this).submit();
      } else {
        let productItems = [];
        let variant = $("#flexi-box-form select[name='id']").val() || "";
        props["_flag"] = "flexibox";

        productItems.push({
          id: variant,
          quantity: 1,
          properties: props
       });
       
       if(props._bundle_product1) {
        onBuyNowClick(this, false, productItems);
        trackEvent("buy_now", variant);
       } else {
        location.reload(true);
       }
        
      }

    setTimeout(function () {
      $("#flexi-box-form").trigger("reset");
      $("#flexi-box-form .quantity-selector").hide();
      $("#flexi-box-form .flex_box_submit").hide();
      $("#flexi-box-form .product_counter").addClass("_hidden");
      $("#flexi-box-form svg.added_to_cart").addClass("_hidden");
      $("#flexi-box-form .product-checkbox").prop("disabled", false);
    }, 900);
  });

  let checkboxes = $("input[type='checkbox']");

  // Quantity selector functionality
  function updateQuantity(input, change) {
    let currentVal = parseInt(input.val()) || 1;
    let newVal = currentVal + change;
    let maxVal = parseInt(input.attr("max")) || 999;
    let minVal = parseInt(input.attr("min")) || 1;

    if (newVal >= minVal && newVal <= maxVal) {
      input.val(newVal);
      input.closest(".product-info").find(".product_counter").text(newVal);
    }
  }

  function getTotalSelectedQuantityInTab(tabId) {
    let total = 0;
    $(`[data-id="tab${tabId}"] .product-checkbox:checked`).each(function () {
      let quantity = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
      total += quantity;
    });
    return total;
  }

  function updateTabCounts(tabId) {
    let totalSelected = getTotalSelectedQuantityInTab(tabId);
    let $tabContent = $(`.tab-content[data-id="tab${tabId}"]`);
    let selectionLimit = parseInt($tabContent.attr("data-product-limit"));
    let currProductDataId = "tab_" + tabId + "_product";

    if (totalSelected === selectionLimit) {
      $(`#checkbox_count_${currProductDataId}`)
        .css("display", "inline-block")
        .html(`<i class="fa-solid fa-check"></i>`);
    } else if (totalSelected > 0) {
      $(`#checkbox_count_${currProductDataId}`)
        .css("display", "inline-block")
        .text(totalSelected);
    } else {
      $(`#checkbox_count_${currProductDataId}`).css("display", "none");
    }

    checkSubmitButtonVisibility();

    // Auto-switch when tab is full
    if (totalSelected === selectionLimit) {
      let nextTab = `tab${parseInt(tabId) + 1}`;
      if ($(`.tab[data-id='${nextTab}']`).length > 0) {
        setTimeout(() => {
          $(`.tab[data-id='${nextTab}']`).click();
          $("#searchbar").val("").trigger("keyup");
          $("html, body").animate({ scrollTop: 0 }, 500, "swing");
        }, 500);
      }
    }
  }

  function checkSubmitButtonVisibility() {
    let totalSelectedAcrossAllTabs = 0;
    $(".tab-content").each(function () {
      let tabId = $(this).attr("data-id").replace("tab", "");
      totalSelectedAcrossAllTabs += getTotalSelectedQuantityInTab(tabId);
    });

    if (totalSelectedAcrossAllTabs == totalproductSelection) {
      $(".flex_box_submit").css("display", "inline-block");
    } else {
      $(".flex_box_submit").css("display", "none");
    }
  }

  // Quantity + button
  $(document).on("click", ".quantity-plus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let currTabId = parseInt(input.attr("data-tab-index"));
    let selectionLimit = parseInt(
      $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
    );

    let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);
    let currentQuantity = parseInt(input.val()) || 1;

    if (totalSelectedInTab - currentQuantity + (currentQuantity + 1) <= selectionLimit) {
      updateQuantity(input, 1);
      updateTabCounts(currTabId);
    }
  });

  // Quantity - button (updated)
  $(document).on("click", ".quantity-minus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let currTabId = parseInt(input.attr("data-tab-index"));
    let currentVal = parseInt(input.val()) || 1;
    let newVal = currentVal - 1;

    if (newVal < 1) {
      // 👇 Uncheck the product when quantity is removed completely
      let $productInfo = input.closest(".product-info");
      let $checkbox = $productInfo.find(".product-checkbox");

      $checkbox.prop("checked", false);
      $productInfo.find(".quantity-input").val(1);
      $productInfo.find(".quantity-selector").hide();
      $productInfo.find(".added_to_cart").addClass("_hidden");
      $productInfo.find(".product_counter").addClass("_hidden");

      updateTabCounts(currTabId);
      return;
    }

    // ✅ Normal quantity decrease
    updateQuantity(input, -1);
    updateTabCounts(currTabId);
  });

  // Direct quantity input (updated)
  $(document).on("change", ".quantity-input", function () {
    let currTabId = parseInt($(this).attr("data-tab-index"));
    let selectionLimit = parseInt(
      $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
    );
    let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);
    let newVal = parseInt($(this).val()) || 0;

    if (newVal < 1) {
      // Auto-uncheck if quantity set to 0
      let $productInfo = $(this).closest(".product-info");
      let $checkbox = $productInfo.find(".product-checkbox");

      $checkbox.prop("checked", false);
      $(this).val(1);
      $productInfo.find(".quantity-selector").hide();
      $productInfo.find(".added_to_cart").addClass("_hidden");
      $productInfo.find(".product_counter").addClass("_hidden");
    } else if (totalSelectedInTab > selectionLimit) {
      $(this).val(1);
      alert("Total quantity cannot exceed the selection limit of " + selectionLimit);
    }

    updateTabCounts(currTabId);
  });

  // Checkbox click handler
  checkboxes.click(function () {
    let currProductDataId = $(this).attr("data-id-products");
    let currTabId = Number(currProductDataId.split("_")[1]);
    let selectionLimit = parseInt(
      $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
    );

    if ($(this).is(":checked")) {
      let currentTabTotal = getTotalSelectedQuantityInTab(currTabId);
      if (currentTabTotal > selectionLimit) {
        $(this).prop("checked", false);
        alert("Selection limit of " + selectionLimit + " reached for this category");
        return;
      }

      $(this).parents(".product-info").find(".quantity-selector").show();
      $(this).parents(".product-info").find(".added_to_cart").removeClass("_hidden");
      $(this).parents(".product-info").find(".product_counter").removeClass("_hidden");
      $(this).closest(".product-info").find(".quantity-input").val(1);
      $(this).parents(".product-info").find(".product_counter").text("1");

      let productTitle = $(this).val().split(" SKU:")[0];
      $(".Message_Bar").removeClass("is-hidden");
      $(".Message_Bar p span").text(productTitle);
      setTimeout(function () {
        $(".Message_Bar").addClass("is-hidden");
        $(".Message_Bar p span").text("");
      }, 2500);
    } else {
      $(this).parents(".product-info").find(".added_to_cart").addClass("_hidden");
      $(this).parents(".product-info").find(".product_counter").addClass("_hidden");
      $(this).parents(".product-info").find(".quantity-selector").hide();
      $(this).closest(".product-info").find(".quantity-input").val(1);
      $(this).parents(".product-info").find(".product_counter").text("1");
    }

    updateTabCounts(currTabId);
  });

  // Disable right-click + F12
  $(document).bind("contextmenu", function (e) {
    e.preventDefault();
  });
  $(document).keydown(function (e) {
    if (e.which === 123) return false;
  });

  // Custom search bar
  $("#searchbar").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $("#collection-list li").filter(function () {
      $(this).toggle($(this).find("a").text().toLowerCase().indexOf(value) > -1);
    });
  });

  // Clear search
  $(".search-clear").click(function () {
    $("#searchbar").val("").trigger("keyup");
  });
}); // document.ready ends
